import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { Icon } from '@/shared/ui/icon'
import { lang } from '@/shared/constants/lang'
import { formatNumber } from '@/shared/util/formatNumber'
import { Glow } from '@/shared/ui/glow'
import { StoriesInfo } from '@/entities/stories/types'

type MainStoriesProps = {
  nickname: string
  avatar: string
  gamedId: string
  info: StoriesInfo
}

export const MainStories = ({ info }: { info: MainStoriesProps }) => {
  const { classes } = useStyles()
  const gigiBalance = formatNumber(info.info.gigi.total)
  const userLang = useUnit($userLanguage)

  const platforms = Object.keys(info.info.platforms)

  const units = lang[userLang].pages.units
  const texts = lang[userLang].pages.profile.stories.mainStories

  const generalStats = [
    {
      title: texts.stats.accountsValue,
      value: info.info.stats?.accounts_value,
    },
    {
      title: texts.stats.assetsValue,
      value: info.info.stats?.assets_value,
    },
    {
      title: texts.stats.gamesOwned,
      value: info.info.stats?.games_count,
    },
    {
      title: texts.stats.itemsOwned,
      value: info.info.stats?.items_count,
    },
  ]
  const gigiStats = [
    {
      title: texts.stats.totalGigi,
      value: info.info.gigi.total,
    },
    {
      title: texts.stats.gigiForAssets,
      value: info.info.gigi.assets,
    },
    {
      title: texts.stats.gigiForGames,
      value: info.info.gigi.games,
    },
    {
      title: texts.stats.gigiForHours,
      value: info.info.gigi.hours,
    },
  ]

  return (
    <div className={classes.root}>
      <Glow
        width={'90%'}
        height={38}
        // left={0}
        filter="blur(40px)"
        top={'140px'}
        borderRadius={357}
        background="rgba(11, 96, 255, 0.3)"
        zIndex={2}
      />
      <Glow
        width={'50%'}
        bottom={'-250px'}
        background="#4A6BFC"
        zIndex={2}
      />
      {/* <div className={classes.backgroundPlayerInfoCard}>
        <div className={classes.playerInfoCard} />
      </div> */}
      <img
        src="/assets/backgrounds/gamedOpacityDecreased.webp"
        alt=""
        className={classes.gamedBlurred}
      />
      <div className={classes.content}>
        <div className={classes.playerInfoCard}>
          <div className={classes.hole}>
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="29"
              viewBox="0 0 28 29"
              fill="none"
            >
              <circle
                cx="14"
                cy="14.3384"
                r="12"
                fill="black"
                stroke="url(#paint0_linear_557_12688)"
                stroke-width="4"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_557_12688"
                  x1="14"
                  y1="4.33838"
                  x2="14"
                  y2="24.3384"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3346C3" />
                  <stop
                    offset="1"
                    stop-color="#5CA1F8"
                  />
                </linearGradient>
              </defs>
            </svg> */}
          </div>
          <div className={classes.userInfo}>
            <div className={classes.userPfp}>
              <img
                src={info.avatar ?? ''}
                alt=""
              />
            </div>
            <div className={classes.userValuesWrapper}>
              <div className={classes.userIdAndUsernameWrapper}>
                <div className={classes.userIdWrapper}>
                  <Icon
                    view="bluePremiumStar"
                    width={20}
                  />
                  <span className={classes.userIdText}>GAMED ID: {info.gamedId}</span>
                </div>
                <span className={classes.usernameText}>{info.nickname}</span>
              </div>
              <div className={classes.gigiBalanceWrapper}>
                <Icon
                  view="gigi"
                  width={24}
                />
                <span className={classes.gigiValueText}>{gigiBalance}</span>
                <span className={classes.gigiUnitText}>{units.gigi}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.connectedPlatformsWrapper}>
          <span className={classes.connectedPlatformsText}>{texts.connectedPlatforms}</span>
          <div className={classes.platformImageWrapper}>
            {platforms.map((item, indx) => {
              const key = item as keyof typeof info.info.platforms
              const value = info.info.platforms[key]
              return (
                <img
                  key={indx}
                  src={`/assets/social/${key}.webp`}
                  alt=""
                  className={classes.platformImg}
                  data-isconnected={value}
                />
              )
            })}
          </div>
        </div>
        <div className={classes.totalPlaytimeWrapper}>
          <span
            className={classes.statTitle}
            style={{ fontSize: '14px' }}
          >
            {texts.stats.totalPlaytime}
          </span>
          <span
            className={classes.statValue}
            style={{ fontSize: '28px', textWrap: 'nowrap' }}
          >
            {info.info.playtime.years}
            {units.years} {info.info.playtime.months}
            {units.minutes} {info.info.playtime.days}
            {units.days} {info.info.playtime.hours}
            {units.hours}
          </span>
        </div>
        <div className={classes.gigiAndGeneralStatsWrapper}>
          <div className={classes.statsWrapper}>
            {generalStats.map((stat) => (
              <div className={classes.statContainer}>
                <span
                  className={classes.statTitle}
                  style={{ fontSize: '12px' }}
                >
                  {stat.title}
                </span>
                <span className={classes.statValue}>{stat.value}</span>
              </div>
            ))}
          </div>
          <div className={classes.statsWrapper}>
            {gigiStats.map((stat) => (
              <div className={classes.statContainer}>
                <span
                  className={classes.statTitle}
                  style={{ fontSize: '12px' }}
                >
                  {stat.title}
                </span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <span className={classes.statValue}>{stat.value}</span>
                  <Icon
                    view="gigiVector"
                    width={16}
                    style={{ alignSelf: 'center' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
